<template>
  <div class="promotion-bar" v-show="componentStore.promotionBar.isShow">
    <div class="container" style="width: 100%;">
      <template v-if="promotionBarContent.length > 0">
        <!-- SSR and the first client render show the first slide as static HTML so the bar
             is in the first paint; the carousel (arrows, auto slide) is enabled after mount -->
        <sib-carousel
          v-if="isMounted && promotionBarContent.length > 1"
          :key="promotionBarContent.length"
          :items="promotionBarContent"
          :options="{ Dots: false }"
          v-slot="slotProps"
        >
          <div class="text--center" v-html="slotProps.item.value"></div>
        </sib-carousel>
        <div
          v-else
          class="text--center"
          v-html="promotionBarContent[0]?.value"
        ></div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import useComponentStore from '@/store/component'
import useSettingStore from '@/store/setting'
import {
  PROMOTION_BAR_PRIORITY_LOW,
  PROMOTION_BAR_TYPE_FIXED_CAMPAIGN,
} from '@/utils'
import { computed } from '@vue/reactivity'
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import useProductStore from '@/store/product'
import { isProductHasTags } from '@/utils/product'

const route = useRoute()
const componentStore = useComponentStore()
const settingStore = useSettingStore()
const productStore = useProductStore()
const isMounted = ref(false)

onMounted(() => {
  isMounted.value = true
})

const promotionBarContent = computed(() => {
  // const pageName = route.meta.pageName
  const allContent = [...componentStore.promotionBar.content]

  // hard code logic for chrismas occasion 2024. Need remove this logic when chrismas occasion finish
  // if (
  //   pageName == 'Product Details' &&
  //   isProductHasTags(productStore.product, ['xmas', 'occasion-Christmas Day'])
  // ) {
  //   settingStore.promotionBar?.campaigns.forEach((campaign) => {
  //     allContent.push({
  //       type: PROMOTION_BAR_TYPE_FIXED_CAMPAIGN,
  //       priority: PROMOTION_BAR_PRIORITY_LOW,
  //       value: campaign,
  //     })
  //   })
  //   allContent.sort((a, b) => {
  //     return a.priority - b.priority
  //   })
  // }

  settingStore.promotionBar?.campaigns.forEach((campaign) => {
    allContent.push({
      type: PROMOTION_BAR_TYPE_FIXED_CAMPAIGN,
      priority: PROMOTION_BAR_PRIORITY_LOW,
      value: campaign,
    })
  })
  allContent.sort((a, b) => {
    return a.priority - b.priority
  })
  return allContent
})

watch(
  () => promotionBarContent.value.length,
  (value) => {
    componentStore.promotionBar.isShow = value > 0
  },
  { immediate: true }
)
</script>

<style lang="scss">
.promotion-bar {
  background-image: url('https://cdn.shopify.com/s/files/1/0560/7233/9630/t/6/assets/promotion-background-pattern.png?v=6357729867794011851637571049');
  // background-color: var(--color-primary);
  // font-size: 14px
  // background-color: #f13c20;
  font-size: 16px;

  background-color: var(--coral-base);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  position: fixed;
  width: 100%;
  height: var(--promotion-bar-height);
  top: 0;
  left: 0;
  z-index: var(--promotion-bar-z-index);
  .carousel {
    &__dots {
      display: none;
    }
    &__button {
      --carousel-button-bg: transparent;
      &:hover {
        --carousel-button-bg: transparent;
      }
    }
  }
}
</style>
